import helper from '@/urls/helper'

const getMendeleevUrlWithParameters = helper.getMendeleevUrlWithParameters
const getMendeleevUrlAllowed = helper.getMendeleevUrlAllowed

export default {
  getMendeleevUrlWithParameters,
  ADMIN: {
    ALLOWED: () => getMendeleevUrlAllowed(
      "admin|cards|cards-list",
      "list"
    )
  },
  USER: {
    ALLOWED: () => getMendeleevUrlAllowed(
      'user|users|profile-status',
      'status',
    ),
    PROFILE: {
      STATUS: (gets = null) => getMendeleevUrlWithParameters(
        'user|users|profile-status',
        'status',
        gets
      ),
      INFO: (gets = null) => getMendeleevUrlWithParameters(
        'user|users|profile-info',
        'info',
        gets
      ),
      LIST:
        (gets = null) => getMendeleevUrlWithParameters(
          'user|users|profile-list',
          'list',
          gets
        ),
      CREATE:
        (gets = null) => getMendeleevUrlWithParameters(
          'user|users|profile-list',
          'create',
          gets
        ),
      CHANGE_EMAIL:
        (gets = null) => getMendeleevUrlWithParameters(
          'user|users|profile-change-email',
          'change_email',
          gets
        ),
      CHANGE_FORGET_PASSWORD:
        (gets = null) => getMendeleevUrlWithParameters(
          'user|users|profile-change-forget-password',
          'change_forget_password',
          gets
        ),
      CHANGE_PASSWORD:
        (gets = null) => getMendeleevUrlWithParameters(
          'user|users|profile-change-password',
          'change_password',
          gets
        ),
      FORGET_PASSWORD:
        (gets = null) => getMendeleevUrlWithParameters(
          'user|users|profile-forget-password',
          'forget_password',
          gets
        ),
      EMAIL_APPROVE:
        (gets = null) => getMendeleevUrlWithParameters(
          'user|users|profile|email|approve',
          'post',
          gets
        ),
      EMAIL_RESEND_APPROVE:
        (gets = null) => getMendeleevUrlWithParameters(
          'user|users|profile-send-approved-registration',
          'send_approved_registration',
          gets
        ),
    },
    MEMBER: {
      LIST:
        (gets = null) => getMendeleevUrlWithParameters(
          'user|members|member-list',
          'list',
          gets
        ),
      PREVIOUS:
        (gets = null) => getMendeleevUrlWithParameters(
          'user|members|member-previous',
          'previous',
          gets
        ),
      CREATE:
        (gets = null) => getMendeleevUrlWithParameters(
          'user|members|member-list',
          'create',
          gets
        ),
      UPDATE:
        (id, gets = null) => getMendeleevUrlWithParameters(
          'user|members|member-detail',
          'update',
          { id: id },
          gets
        ),
      PARTIAL_UPDATE:
        (id, gets = null) => getMendeleevUrlWithParameters(
          'user|members|member-detail',
          'partial_update',
          { id: id },
          gets
        ),
      REVOKE_AGREEMENT:
        (id, gets = null) => getMendeleevUrlWithParameters(
          'user|members|member-revoke-agreement',
          'revoke_agreement',
          { id: id },
          gets
        ),
      CHANGE_MAILING:
        (gets = null) => getMendeleevUrlWithParameters(
          'user|members|member-change-mailing',
          'change_mailing',
          gets
        ),
      RESEND_MAILING:
        (gets = null) => getMendeleevUrlWithParameters(
          'user|users|profile-send-approved-email',
          'send_approved_email',
          gets
        ),
      SCHOOLCHILD: {
        LIST:
          (gets = null) => getMendeleevUrlWithParameters(
            'user|members|schoolchild-list',
            'list',
            gets
          ),
        CREATE:
          (gets = null) => getMendeleevUrlWithParameters(
            'user|members|schoolchild-list',
            'create',
            gets
          ),
        UPDATE:
          (id, gets = null) => getMendeleevUrlWithParameters(
            'user|members|schoolchild-detail',
            'update',
            { id: id },
            gets
          ),
        PARTIAL_UPDATE:
          (id, gets = null) => getMendeleevUrlWithParameters(
            'user|members|schoolchild-detail',
            'partial_update',
            { id: id },
            gets
          ),
        REPRESENTATIVE: {
          LIST:
            (gets = null) => getMendeleevUrlWithParameters(
              'user|members|schoolchild|representative-list',
              'list',
              gets
            ),
          UPDATE:
            (id, gets = null) => getMendeleevUrlWithParameters(
              'user|members|schoolchild|representative-detail',
              'update',
              { id: id },
              gets
            ),
          PARTIAL_UPDATE:
            (id, gets = null) => getMendeleevUrlWithParameters(
              'user|members|schoolchild|representative-detail',
              'partial_update',
              { id: id },
              gets
            ),
        }
      },
      SCIENCE: {
        LIST:
          (gets = null) => getMendeleevUrlWithParameters(
            'user|members|science-list',
            'list',
            gets
          ),
        CREATE:
          (gets = null) => getMendeleevUrlWithParameters(
            'user|members|science-list',
            'create',
            gets
          ),
        UPDATE:
          (id, gets = null) => getMendeleevUrlWithParameters(
            'user|members|science-detail',
            'update',
            { id: id },
            gets
          ),
        PARTIAL_UPDATE:
          (id, gets = null) => getMendeleevUrlWithParameters(
            'user|members|science-detail',
            'partial_update',
            { id: id },
            gets
          )
      },
      STUDENT: {
        LIST:
          (gets = null) => getMendeleevUrlWithParameters(
            'user|members|student-list',
            'list',
            gets
          ),
        CREATE:
          (gets = null) => getMendeleevUrlWithParameters(
            'user|members|student-list',
            'create',
            gets
          ),
        UPDATE:
          (id, gets = null) => getMendeleevUrlWithParameters(
            'user|members|student-detail',
            'update',
            { id: id },
            gets
          ),
        PARTIAL_UPDATE:
          (id, gets = null) => getMendeleevUrlWithParameters(
            'user|members|student-detail',
            'partial_update',
            { id: id },
            gets
          )
      },
      POSTGRADUATE: {
        LIST:
          (gets = null) => getMendeleevUrlWithParameters(
            'user|members|postgraduate-list',
            'list',
            gets
          ),
        CREATE:
          (gets = null) => getMendeleevUrlWithParameters(
            'user|members|postgraduate-list',
            'create',
            gets
          ),
        UPDATE:
          (id, gets = null) => getMendeleevUrlWithParameters(
            'user|members|postgraduate-detail',
            'update',
            { id: id },
            gets
          ),
        PARTIAL_UPDATE:
          (id, gets = null) => getMendeleevUrlWithParameters(
            'user|members|postgraduate-detail',
            'partial_update',
            { id: id },
            gets
          )
      },
      AGREEMENTS: {
        LIST:
          (gets = null) => getMendeleevUrlWithParameters(
            'user|members|agreement-list',
            'list',
            gets
          ),
        DETAIL:
          (id, gets = null) => getMendeleevUrlWithParameters(
            'user|members|agreement-detail',
            'retrieve',
            { id: id },
            gets
          ),
        WITHDRAW:
          (id, gets = null) => getMendeleevUrlWithParameters(
            'user|members|agreement-withdrawal',
            'withdrawal',
            { id: id },
            gets
          )
      },
      APPLICATION: {
        UPDATE:
          (gets = null) => getMendeleevUrlWithParameters(
            'user|members|application|update',
            'post',
            gets
          ),
      },
      SIMPLIFIED: {
        SCHOOLCHILD:
          (gets = null) => getMendeleevUrlWithParameters(
            'user|members|schoolchild-simplified',
            'simplified',
            gets
          ),
        STUDENT:
          (gets = null) => getMendeleevUrlWithParameters(
            'user|members|student-simplified',
            'simplified',
            gets
          ),
        POSTGRADUATE:
          (gets = null) => getMendeleevUrlWithParameters(
            'user|members|postgraduate-simplified',
            'simplified',
            gets
          ),
        SCIENCE:
          (gets = null) => getMendeleevUrlWithParameters(
            'user|members|science-simplified',
            'simplified',
            gets
          ),
      },
    },
    PARTNERS: {
      LIST:
        (gets = null) => getMendeleevUrlWithParameters(
          'user|partners|partners-list',
          'list',
          gets
        ),
      LAZY:
        (gets = null) => getMendeleevUrlWithParameters(
          'user|partners|partners-lazy',
          'lazy',
          gets
        ),
      NEW:
        (gets = null) => getMendeleevUrlWithParameters(
          'user|partners|partners-new',
          'new',
          gets
        ),
      DETAIL:
        (id, gets = null) => getMendeleevUrlWithParameters(
          'user|partners|partners-detail',
          'retrieve',
          { id: id },
          gets
        ),
      PROMOCODES: {
        LIST:
          (gets = null) => getMendeleevUrlWithParameters(
            'user|partners|promocodes-list',
            'list',
            gets
          ),
        LAZY:
          (gets = null) => getMendeleevUrlWithParameters(
            'user|partners|promocodes-lazy',
            'lazy',
            gets
          ),
        USED:
          (gets = null) => getMendeleevUrlWithParameters(
            'user|partners|promocodes|used-list',
            'list',
            gets
          ),
        BIND:
          (id, gets = null) => getMendeleevUrlWithParameters(
            'user|partners|promocodes-bind',
            'bind',
            { id: id },
            gets
          ),
        DETAIL:
          (id, gets = null) => getMendeleevUrlWithParameters(
            'user|partners|promocodes-detail',
            'retrieve',
            { id: id },
            gets
          ),
      }
    },
    MAILS: {
      LIST:
        (gets = null) => getMendeleevUrlWithParameters(
          'user|members|member-mails',
          'mails',
          gets
        ),
    },
    CALENDAR: {
      EVENTS: {
        LIST:
          (gets = null) => getMendeleevUrlWithParameters(
            'user|events|events-list',
            'list',
            gets
          ),
        DETAIL:
          (id, gets = null) => getMendeleevUrlWithParameters(
            'user|events|events-detail',
            'retrieve',
            { id: id },
            gets
          ),
        APPLICATIONS: {
          LIST:
            (gets = null) => getMendeleevUrlWithParameters(
              'user|events|event-related|registrations-list',
              'list',
              gets
            ),
          CREATE:
            (event_id, gets = null) => getMendeleevUrlWithParameters(
              'user|events|event-related|registrations-list',
              'create',
              { event_id },
              gets
            ),
          CANCEL:
            (event_id, app_id, gets = null) => getMendeleevUrlWithParameters(
              'user|events|event-related|registrations-cancel',
              'cancel',
              { event_id, id: app_id },
              gets
            ),
        }

      },
      APPLICATIONS: {
        LIST:
          (gets = null) => getMendeleevUrlWithParameters(
            'user|events|registrations-list',
            'list',
            gets
          ),
        CANCEL:
          (gets = null) => getMendeleevUrlWithParameters(
            'user|events|registrations-cancel',
            'cancel',
            gets
          ),
      }

    },
    INFOS: {
      QUESTIONS: {
        LIST:
          (gets = null) => getMendeleevUrlWithParameters(
            'user|infos|questions-list',
            'list',
            gets
          ),
        DETAIL:
          (id, gets = null) => getMendeleevUrlWithParameters(
            'user|infos|questions-detail',
            'retrieve',
            { id: id },
            gets
          ),
      },
      NEWS: {
        LIST:
          (gets = null) => getMendeleevUrlWithParameters(
            'user|infos|news-lazy',
            'lazy',
            gets
          ),
        DETAIL:
          (id, gets = null) => getMendeleevUrlWithParameters(
            'user|infos|news-detail',
            'retrieve',
            { id: id },
            gets
          ),
      },
      AGREEMENTS: {
        LIST:
          (gets = null) => getMendeleevUrlWithParameters(
            'user|infos|agreements-list',
            'list',
            gets
          ),
        DETAIL:
          (id, gets = null) => getMendeleevUrlWithParameters(
            'user|infos|agreements-detail',
            'retrieve',
            { id: id },
            gets
          ),
        ACCEPT:
          (gets = null) => getMendeleevUrlWithParameters(
            'user|infos|agreements-accept',
            'accept',
            gets
          ),
      },
    },
    CARD: {
      LIST:
        (gets = null) => getMendeleevUrlWithParameters(
          'user|cards|card-list',
          'list',
          gets
        ),
      GOOGLE_WALLET:
        (card_id, gets = null) => getMendeleevUrlWithParameters(
          'user|cards|wallet_google',
          'get',
          { card_id: card_id },
          gets
        ),
      APPLE_WALLET:
        (card_id, gets = null) => getMendeleevUrlWithParameters(
          'user|cards|wallet_apple',
          'get',
          { card_id: card_id },
          gets
        ),
    },
    FEEDBACKS: {
      LIST:
        (gets = null) => getMendeleevUrlWithParameters(
          'user|feedback|feedbacks-list',
          'list',
          gets
        ),
      CREATE:
        (gets = null) => getMendeleevUrlWithParameters(
          'user|feedback|feedbacks-list',
          'create',
          gets
        ),
      DETAIL:
        (id, gets = null) => getMendeleevUrlWithParameters(
          'user|feedback|feedbacks-detail',
          'retrieve',
          { id: id },
          gets
        ),
      UPDATE:
        (id, gets = null) => getMendeleevUrlWithParameters(
          'user|feedback|feedbacks-detail',
          'update',
          { id: id },
          gets
        ),
      PARTIAL_UPDATE:
        (id, gets = null) => getMendeleevUrlWithParameters(
          'user|feedback|feedbacks-detail',
          'partial_update',
          { id: id },
          gets
        ),
      FILES: {
        LIST:
          (feedback_id, gets = null) => getMendeleevUrlWithParameters(
            'user|feedback|file-list',
            'list',
            { feedback_id: feedback_id },
            gets
          ),
        CREATE:
          (feedback_id, gets = null) => getMendeleevUrlWithParameters(
            'user|feedback|file-list',
            'create',
            { feedback_id: feedback_id },
            gets
          ),
        DETAIL:
          (feedback_id, id, gets = null) => getMendeleevUrlWithParameters(
            'user|feedback|file-detail',
            'retrieve',
            { feedback_id: feedback_id, id: id },
            gets
          ),
        UPDATE:
          (feedback_id, id, gets = null) => getMendeleevUrlWithParameters(
            'user|feedback|file-detail',
            'update',
            { feedback_id: feedback_id, id: id },
            gets
          ),
        PARTIAL_UPDATE:
          (feedback_id, id, gets = null) => getMendeleevUrlWithParameters(
            'user|feedback|file-detail',
            'partial_update',
            { feedback_id: feedback_id, id: id },
            gets
          ),
      },
    },
  },
  AUTH: {
    LOGIN:
      (gets = null) => getMendeleevUrlWithParameters(
        'authenticate|authentication|login',
        "post",
        gets
      ),
    LOGOUT:
      (gets = null) => getMendeleevUrlWithParameters(
        'authenticate|authentication|logout',
        'post',
        gets
      ),
    SESSION: {
      ALIVE:
        (gets = null) => getMendeleevUrlWithParameters(
          'authenticate|authentication|session|alive',
          'get',
          gets
        )
    },
    TOKEN: {
      ALIVE:
        (gets = null) => getMendeleevUrlWithParameters(
          'authenticate|authentication|token|alive',
          'post',
          gets
        )
    },
    SCIENCE_ID: {
      OAUTH_REDIRECT:
        (gets = null) => getMendeleevUrlWithParameters(
          'authenticate|authentication|scienceid|oauth|redirect',
          'get',
          gets
        ),
      OAUTH_LOGIN:
        (gets = null) => getMendeleevUrlWithParameters(
          'authenticate|authentication|scienceid|oauth|login',
          'post',
          gets
        ),
    },
  },
  SCIENCE_ID: {
    REGISTER_GET:
      (science_id, gets = null) => getMendeleevUrlWithParameters(
        'scienceid-register',
        'get',
        null,
        { science_id: science_id }
      ),
    REGISTER_POST:
      (science_id, gets = null) => getMendeleevUrlWithParameters(
        'scienceid-register',
        'post',
        null,
        { science_id: science_id }
      ),
    GET_DATA:
      (gets = null) => getMendeleevUrlWithParameters(
        'scienceid-from-data',
        'get',
        gets
      ),
    REDIRECTTO:
      (gets = null) => getMendeleevUrlWithParameters(
        'scienceid-redirectto',
        'get',
        gets
      ),
    SEARCH:
      (gets = null) => getMendeleevUrlWithParameters(
        'scienceid-search',
        'post',
        gets
      ),
    LINKING:
      (gets = null) => getMendeleevUrlWithParameters(
        'scienceid-linking',
        'post',
        gets
      ),
  },
}
